import * as actionTypes from './actionTypes';
import admSvc from '../../axios-admsvc';
import { personalInfoSuccess, fetchPortalConfigSuccess, fetchPortalConfigFailure, selectMember } from "./member";
import {concatePortals, createSdkPortalObject, getEnabledPortalUrl, USERNAME_NOT_AVAILABLE_MATCHER_REGEX, USER_ALREADY_EXISTS_MATCHER_REGEX, USERNAME_ALREADY_EXISTS_MATCHER_REGEX} from '../../shared/utility';
import {SDK_ENABLE, SDK_PORTAL_LIST, USERNAME_NOT_AVAILABLE_ERROR_MESSAGE} from '../../shared/Constants';
import * as urls from '../../shared/ApplicationUrls';

// Modify & Verify Account
export const modifyAccountDetails = (personalInfo, idType) => {
    return dispatch => {
        dispatch(modifyAccountStart());
        admSvc.post("/members/memberAccount", personalInfo).then(response => {
            // console.log("[modifyAccount] modifyAccount Response: ",response.data);
            if (response.data.nameUpdationSuccess || response.data.emailUpdated || response.data.emailVerified 
                    || response.data.phoneUpdated || response.data.phoneVerified 
                    || response.data.secondaryEmailUpdated || response.data.secondaryEmailVerified
                    || response.data.dobUpdated || response.data.zipCodeUpdated || response.data.isUserNameUpdated) {
                dispatch(selectMember({uuid:personalInfo.uuid}, idType, false))
                dispatch(modifyAccountSuccess())
                dispatch(personalInfoSuccess(personalInfo, response.data));
                dispatch(modifyAccountFailure({ errorData: response.data.status.code === 'FAILURE'?response.data:null}));
            } else {
                dispatch(modifyAccountFailure({ errorData: response.data }));
            }
        }).catch(error => {
            // console.log("[modifyAccount] Error during modifyAccount: ", error);
            dispatch(modifyAccountFailure({message: "Modify account failed. Pls try again"}));
            // return Promise.reject(error.response);
            return error.response;
        });
    }
}

export const modifyAccountStart = () => {
    return {
        type: actionTypes.MODIFY_ACCOUNT_START,
    }
}

export const modifyAccountSuccess = () => {
    return {
        type: actionTypes.MODIFY_ACCOUNT_SUCCESS,
    }
}

export const modifyAccountFailure = (errorObj) => {
    const errorData = errorObj.errorData;
    let errorMsg = errorData ? errorData.error.errorMsg : errorObj.message ? errorObj.message : '';
    
    if (errorData && errorData.errors) {
        errorData.errors.forEach(element => {
            // checking error code for unique email Id
            if(element.errorId === 40915){
                errorMsg = element.errorDesc;
            }
        });
    }

    if(errorMsg.match(USERNAME_NOT_AVAILABLE_MATCHER_REGEX) || errorMsg.match(USER_ALREADY_EXISTS_MATCHER_REGEX) || errorMsg.match(USERNAME_ALREADY_EXISTS_MATCHER_REGEX)){
        errorMsg = USERNAME_NOT_AVAILABLE_ERROR_MESSAGE;
    }
    
    return {
        type: actionTypes.MODIFY_ACCOUNT_FAILURE,
        error: {message: errorMsg}
    }
}

export const setPersInfoDisplayMessage = (message) => {
    return {
        type: actionTypes.SET_PERSINFO_DISPLAY_MESSAGE,
        message: message
    }
}

export const setMemPopUpDisplayMessage = (message) => {
    return {
        type: actionTypes.SET_MEMPOPUP_DISPLAY_MESSAGE,
        popUpMessage: message
    }
}

//fetch portals
export const fetchMemberAccountPortals = () => {
    // console.log("[Reference Data] Fetch Member Account Portals Start ");
    return (dispatch, getState) => {
        dispatch(fetchMemberAccountPortalsStart());
        admSvc.get(getEnabledPortalUrl(true,"/screens/AccountAdmin/"))
            .then(response => {
                let portals = response.data.portals;
                let localStorageSdkList = JSON.parse(localStorage.getItem(SDK_PORTAL_LIST));
                if(!localStorageSdkList){
                    if(SDK_ENABLE){
                        admSvc.get(urls.FETCH_PORTAL_CONFIG)
                        .then(portalResponse => {
                            if(portalResponse.data.payload){
                                dispatch(fetchPortalConfigSuccess(portalResponse.data.payload));
                                let sdkPortalList = createSdkPortalObject(portalResponse.data.payload);
                                portals = concatePortals(portals, sdkPortalList, "adminAccount");
                                dispatch(fetchMemberAccountPortalsSuccess(portals));
                                dispatch(fetchMemberAccountPortalsInfo(portals));
                            }
                        }).catch(error => {
                            dispatch(fetchPortalConfigFailure(error));
                            dispatch(fetchMemberAccountPortalsSuccess(portals));
                            dispatch(fetchMemberAccountPortalsInfo(portals));
                        });
                    }else{
                        dispatch(fetchPortalConfigFailure("SDK Portal Fetching is Disabled"));
                        dispatch(fetchMemberAccountPortalsSuccess(portals));
                        dispatch(fetchMemberAccountPortalsInfo(portals));
                    }
                }else{
                    portals = concatePortals(portals, localStorageSdkList, "adminAccount");
                    dispatch(fetchMemberAccountPortalsSuccess(portals));
                    dispatch(fetchMemberAccountPortalsInfo(portals));
                }
            })
            .catch(error => {
                // console.log("[Reference Data] Fetch Portals Error: ", error);
                dispatch(fetchMemberAccountPortalsFailure(error));
                // return Promise.reject(error.response);
                return error.response
            });
    }
}

export const fetchMemberAccountPortalsStart = () => {
    return {
        type: actionTypes.FETCH_MEMBER_ACCOUNT_PORTALS_START
    }
}

export const fetchMemberAccountPortalsSuccess = (portals, ) => {
    // console.log("[Reference Data] Fetch Account Portals Success: ", portals);
    return {
        type: actionTypes.FETCH_MEMBER_ACCOUNT_PORTALS_SUCCESS,
        portals: portals.sort((a, b) => (a.portalDisplayName > b.portalDisplayName) ? 1 : -1)
    }
}

export const fetchMemberAccountPortalsFailure = (error) => {
    return {
        type: actionTypes.FETCH_MEMBER_ACCOUNT_PORTALS_FAILURE,
        error: error
    }
}


// fetch portal language Info
export const fetchMemberAccountPortalsInfo = (portals) => {
    return dispatch => {
        const portalIds = portals.filter(portal => portal.prtlId).map(portal => portal.prtlId);
        dispatch(fetchLanguageInfoAllPortals(portalIds));
    }
}

export const fetchLanguageInfoAllPortals = (portalIds) => {
    return dispatch => {
        admSvc.post('/portals/enabled/languages', {portalIds: [...portalIds]}).then(response => {
        dispatch(fetchLanguageInfoSuccess(response.data));
        }).catch(error => {
            dispatch(fetchLanguageInfoFailure(error));
            // return Promise.reject(error.response);
            return error.response;
        });
    }
}

export const fetchLanguageInfoSuccess = (portalInfo) => {
    return {
        type: actionTypes.FETCH_LANGUAGE_INFO_SUCCESS,
        portalInfo: portalInfo
    }
}

export const fetchLanguageInfoFailure = (error) => {
    return {
        type: actionTypes.FETCH_LANGUAGE_INFO_FAILURE,
        error: error
    }
}
export const mergePortalInfoAdminAccount = (portalsInfo, portalConfigPortalList) => {
    let updatedPortalInfo = {};
    for (const key in portalConfigPortalList) {
        const element = portalConfigPortalList[key];
        updatedPortalInfo[element.portalShortName] = element;
    }
    portalsInfo = {
        ...portalsInfo,
        ...updatedPortalInfo
    }
    return{
        type: actionTypes.MERGE_PORTALS_LIST_ADMIN,
        portalInfo: portalsInfo
    }
}
